// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"np","tile":"nq","imageWrapper":"nr","img":"ns","header":"nt","caption":"nu"};